import { Row, Col } from "react-bootstrap";
import { ButtonLink } from "@/components/lib/ButtonLink";
import { OrderListTable } from "@/components/entities/order/OrderListTable";
import { useOutletContext } from "react-router-dom";
import React from "react";

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

export const OrderList = () => {
    const { setTitle } = useOutletContext<ContextType>()
  
    React.useEffect(() => {
      setTitle('Livraisons')
    }, [setTitle])
  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row className='relative back-g'>
        <Col className="">
          <ButtonLink
            name={'Nouvelle livraison'}
            href={'/livraisons/creation'}
            icon={'Plus'}
          />
        </Col>
      </Row>
      <Row className='mt-md-4'>
        <Col>
          <OrderListTable />
        </Col>
      </Row>
    </>
  )
};
